/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel-layer surface for the My Hub domain enums a view renders off.
 *
 * `TMyHubActionType` (how the service names the buttons an item affords) and
 * `TMyHubType` (what kind of thing a My Hub tile is — a recording, a folder)
 * are Domain contracts and live in `model/types/TMyHubDto.ts`. Views must not
 * reach into `src/model/**` directly (MVVM: model → viewModel → views,
 * enforced by `scripts/lint-mvvm.cjs`), so this is the sanctioned path for a
 * view that renders one of those buttons or routes a tile by its type — the
 * same shape as `viewModel/locale` and `viewModel/logging`.
 *
 * Deliberately its own file rather than a line in `viewModel/myHub/index.ts`:
 * the enums are used as values by presentational files, and that barrel would
 * bring the My Hub slices and thunks along with it.
 */
export { TMyHubActionType, TMyHubType } from "../../model/types";

export default {};
